import { QuestionType } from 'lib/question/constants';
import { assetUrl } from './assets';

//Users Constants
export const LOGIN = 'LOGIN';
export const LOGIN_ATTEMPT = 'LOGIN_ATTEMPT';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const FETCH_CLASS_INFO = 'FETCH_CLASS_INFO';
export const SELECT_ACTIVE_CLASS = 'SELECT_ACTIVE_CLASS';
export const FETCH_USER_SUMMARY = 'FETCH_USER_SUMMARY';
export const STUDENT_PROFILE_UPDATE = 'STUDENT_PROFILE_UPDATE';
export const UPDATE_GAMIFY_INFO = 'UPDATE_GAMIFY_INFO';
export const UPDATE_ONBOARDING_STATUS = 'UPDATE_ONBOARDING_STATUS';

//Questions Constants
export const GET_QUESTIONS_BY_LESSON = 'GET_QUESTIONS_BY_LESSON';
export const CLEAR_QUESTIONS = 'CLEAR_QUESTIONS';
export const SET_QUESTIONS_LOADING = 'SET_QUESTIONS_LOADING';

//Question History Constants
export const ADD_QUESTION_HISTORY = 'ADD_QUESTION_HISTORY';
export const GET_QUESTION_HISTORY = 'GET_QUESTION_HISTORY';
export const CLEAR_QUESTION_HISTORY = 'CLEAR_QUESTION_HISTORY';
export const GET_LESSON_ATTEMPTS = 'GET_LESSON_ATTEMPTS';
export const UPDATE_QUESTION_HISTORY = 'UPDATE_QUESTION_HISTORY';

export const FETCH_CERTIFICATION_QUIZ = 'FETCH_CERTIFICATION_QUIZ';

//Lessons
export const GET_LESSON_BY_ID = 'GET_LESSON_BY_ID';
export const FETCH_UPCOMING_LESSONS = 'FETCH_UPCOMING_LESSONS';
export const FETCHING_PAST_LESSONS = 'FETCHING_PAST_LESSONS';
export const FETCH_PAST_LESSONS = 'FETCH_PAST_LESSONS';
export const GET_CURRENT_LESSON_TOKEN = 'GET_CURRENT_LESSON_TOKEN';
export const LESSON_STATUS = Object.freeze({
  pending: 'PENDING',
  scheduled: 'SCHEDULED',
  inProgress: 'IN_PROGRESS',
  done: 'DONE',
  cancelled: 'CANCELLED',
});

export const PAST_LESSON_STATUSES = [LESSON_STATUS.done, LESSON_STATUS.cancelled];
//###
export const SET_INSTRUCTOR_FROM_LESSON = 'SET_INSTRUCTOR_FROM_LESSON';
export const SET_CUSTOMER_FROM_LESSON = 'SET_CUSTOMER_FROM_LESSON';
export const CANCEL_LESSON = 'CANCEL_LESSON';
export const FETCH_WRITING_PAD = 'FETCH_WRITING_PAD';
// Audio
export const FETCH_AUDIO_CLIPS_FOR_LESSON = 'FETCH_AUDIO_CLIPS_FOR_LESSON';
// slides
export const FETCH_SLIDES = 'FETCH_SLIDES';
export const FETCH_TOPIC_SLIDES = 'FETCH_TOPIC_SLIDES';
export const SLIDE_POSITION = 'SLIDE_POSITION';
export const FLASHCARD_POSITION = 'FLASHCARD_POSITION';
//Reviews
export const CREATE_REVIEW = 'CREATE_REVIEW';
export const FETCH_REVIEW = 'FETCH_REVIEW';
export const FETCH_REVIEWS = 'FETCH_REVIEWS';
export const LOADING_REVIEWS = 'LOADING_REVIEWS';

// Content Tags
export const SET_CONTENT_TAGS = 'SET_CONTENT_TAGS';
export const SET_CONTENT_TAG_TREE = 'SET_CONTENT_TAG_TREE';

//Vocab
export const FETCH_VOCABS_BY_LESSON = 'FETCH_VOCABS_BY_LESSON';
export const FETCH_ALL_VOCABS = 'FETCH_ALL_VOCABS';
export const APPEND_LESSON_VOCAB = 'APPEND_LESSON_VOCAB';
export const CLEAR_VOCABS = 'CLEAR_VOCABS';

//Quiz
export const SUBMIT_QUIZ = 'SUBMIT_QUIZ';

//UserSubjectSettings
export const FETCH_USER_SUBJECT_SETTINGS = 'FETCH_USER_SUBJECT_SETTINGS';

// app-notification redux
export const UPDATE_APP_NOTIFICATION_STATUS = 'UPDATE_APP_NOTIFICATION_STATUS';
export const UPDATE_APP_NOTIFICATIONS = 'UPDATE_APP_NOTIFICATIONS';
export const ADD_NEW_APP_NOTIFICATION = 'ADD_NEW_APP_NOTIFICATION';
export const CLEAR_APP_NOTIFICATIONS = 'CLEAR_APP_NOTIFICATIONS';

// Avatar actions
export const UPDATE_ROADMAP_AVATARS = 'UPDATE_ROADMAP_AVATARS';
export const UPDATE_AVATAR_VIDEO_PLAYER = 'UPDATE_AVATAR_VIDEO_PLAYER';

//middleware
export const SERVER = 'SERVER';

//misc
export const SUPPORT_EMAIL = 'csteam@meeopp.com';

//Paths
export const CLOUDINARY_UPLOAD_PRESET = 'yd1z9dlx';
export const CLOUDINARY_UPLOAD_URL = 'https://api.cloudinary.com/v1_1/meeup/upload';

export const CLOUDINARY_UPLOAD_ACTION = `${CLOUDINARY_UPLOAD_URL}?upload_preset=${CLOUDINARY_UPLOAD_PRESET}`;

export const FETCH_STUDENT_BOOKING_OPTION = 'FETCH_STUDENT_BOOKING_OPTION';

// webrtc
export const ME = '_me_';
export const INIT = 'INIT';
export const END_CALL = 'END_CALL';
export const CALL_STATUS = 'CALL_STATUS';

export const PEER_ADD = 'PEER_ADD';
export const PEER_REMOVE = 'PEER_REMOVE';
export const PEERS_DESTROY = 'PEERS_DESTROY';

export const PEER_EVENT_ERROR = 'error';
export const PEER_EVENT_CONNECT = 'connect';
export const PEER_EVENT_CLOSE = 'close';
export const PEER_EVENT_SIGNAL = 'signal';
export const PEER_EVENT_STREAM = 'stream';
export const PEER_EVENT_DATA = 'data';

export const SOCKET_EVENT_SIGNAL = 'signal';
export const SOCKET_EVENT_USERS = 'users';
export const SOCKET_EVENT_MESSAGES = 'messages';
export const SOCKET_EVENT_NEW_MESSAGE = 'new_message';

export const STREAM_ADD = 'PEER_STREAM_ADD';
export const STREAM_REMOVE = 'PEER_STREAM_REMOVE';

export const PAGINATION_LIMIT = 10;

export const QUIZ_AUDIO_CLIPS_POSITION = Object.freeze({
  top: 'TOP',
  bottom: 'BOTTOM',
});

export const LESSON_TYPES = {
  WRITING: 'WRITING',
  CHALLENGE_REVIEW: 'CHALLENGE_REVIEW',
  SOLO: 'SOLO',
  WGT: 'WGT',
  DEFAULT: 'DEFAULT',
  CORE_ITEMS_IWGT: 'CORE_ITEMS_IWGT',
  QUIZ: 'QUIZ',
  PLAYBOOK: 'PLAYBOOK',
};

export const SESSION_TYPE = Object.freeze({
  WGT: 'WGT',
  CHALLENGE: 'CHALLENGE',
  ASSESSMENT: 'ASSESSMENT',
  ONE_ON_ONE: 'ONE_ON_ONE',
});

// Use it i.e.: lesson[LESSON_CONTENT_KEY_MAP[LESSON_TYPES.SOLO]]
export const LESSON_CONTENT_KEY_MAP = {
  [LESSON_TYPES.SOLO]: 'topic',
  [LESSON_TYPES.WGT]: 'presentation',
  [LESSON_TYPES.CORE_ITEMS_IWGT]: 'coreItemsIWGT',
  [LESSON_TYPES.PLAYBOOK]: 'publishedPlaybook',
};

export const AUDIO_URLS = {
  CORRECT_ANSWER: 'https://d3htal48xcmox4.cloudfront.net/audio/correct.mp3',
  INCORRECT_ANSWER: 'https://d3htal48xcmox4.cloudfront.net/audio/incorrect.mp3',
  LIVE_NOTIFICATION: 'https://d3htal48xcmox4.cloudfront.net/audio/notification.mp3',
  MEECARD_CHECK_IT: 'https://d3htal48xcmox4.cloudfront.net/audio/meecard-check-it.mp3',
};

// if you have to change this object, you have to change on backend as well to keep them in sync
export const QUESTION_TYPES_MAP = QuestionType;

export const QUESTION_WRITTEN_TYPES = [
  QUESTION_TYPES_MAP.short,
  QUESTION_TYPES_MAP.openEndedWriting,
];

export const QUESTION_ORAL_TYPES = [QUESTION_TYPES_MAP.spoken, QUESTION_TYPES_MAP.openEndedOral];

export const OPEN_ENDED_QUESTION_TYPES = [
  QUESTION_TYPES_MAP.openEndedOral,
  QUESTION_TYPES_MAP.openEndedWriting,
];

export const ORAL_QUESTION_TYPES = Object.freeze([
  QUESTION_TYPES_MAP.spoken,
  QUESTION_TYPES_MAP.openEndedOral,
]);
export const CDNIS_QUESTION_TYPES = Object.freeze([
  QUESTION_TYPES_MAP.multiChoiceImage,
  QUESTION_TYPES_MAP.multiChoiceText,
]);

export const PARENT_QUESTION_TYPES = [
  QUESTION_TYPES_MAP.matchingParent,
  QUESTION_TYPES_MAP.tableParent,
  QUESTION_TYPES_MAP.tableMultiParent,
];

export const SHORT_ANSWER_TYPES_MAP = Object.freeze({
  oneLine: 'ONE_LINE',
  trueFalse: 'TRUE_FALSE',
});

export const USER_TYPES_MAP = Object.freeze({
  student: 'STUDENT',
  instructor: 'INSTRUCTOR',
  schoolStaff: 'SCHOOL_STAFF',
  meeoppStaff: 'MEEOPP_STAFF',
});

export const SUBJECTS_MAP = Object.freeze({
  general: 'GENERAL',
  mandarin: 'MANDARIN',
});

export const USER_SUBJECTS = Object.values(SUBJECTS_MAP);

export const QUESTION_MAX_ATTEMPTS = 3;

export const WEB_ASSETS_URL = 'https://web.meeopp.com';

// Note: Some of the utils are contained in school-year-utils.js
export const YEAR_SYSTEMS = Object.freeze({
  UK: 'UK',
  HK: 'HK',
  US: 'US',
  SG: 'SG',
  UNIVERISTY: 'University',
});

function getYearVal(prefix, index) {
  const year = `${index + 1}`.padStart(2, '0');
  return `${prefix}_${year}`;
}

export const YEAR_NAMES = Object.freeze({
  [YEAR_SYSTEMS.UK]: [...new Array(13)].reduce((acc, value, index) => {
    acc[getYearVal('YEAR', index)] = `Year ${index + 1}`;
    return acc;
  }, {}),
  [YEAR_SYSTEMS.HK]: {
    ...[...new Array(6)].reduce((acc, value, index) => {
      acc[getYearVal('HK_PRIMARY', index)] = `Primary ${index + 1}`;
      return acc;
    }, {}),
    ...[...new Array(6)].reduce((acc, value, index) => {
      acc[getYearVal('HK_FORM', index)] = `Form ${index + 1}`;
      return acc;
    }, {}),
  },
  [YEAR_SYSTEMS.US]: {
    US_KINDERGARTEN: 'Kindergarten',
    ...[...new Array(12)].reduce((acc, value, index) => {
      acc[getYearVal('US_GRADE', index)] = `Grade ${index + 1}`;
      return acc;
    }, {}),
  },
  [YEAR_SYSTEMS.SG]: {
    ...[...new Array(6)].reduce((acc, value, index) => {
      acc[getYearVal('SG_PRIMARY', index)] = `Primary ${index + 1}`;
      return acc;
    }, {}),
    ...[...new Array(5)].reduce((acc, value, index) => {
      acc[getYearVal('SG_SECONDARY', index)] = `Secondary ${index + 1}`;
      return acc;
    }, {}),
  },
  [YEAR_SYSTEMS.UNIVERSITY]: {
    BACHELOR: 'Bachelor (Undergrad)',
    MASTER: 'Master (Postgrad)',
    DOCTORATE: 'Doctorate (PhD)',
  },
});

export const SCHOOL_CLASS_STAGE = Object.freeze({
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  UNKNOWN: 'unknown',
});

export const YEAR_DISPLAY_NAME_MAP = Object.freeze(
  Object.values(YEAR_NAMES).reduce(
    (acc, yearNames) => ({
      ...acc,
      ...yearNames,
    }),
    {}
  )
);

export const CURRICULUM_SPOKEN_PERCENT_MAP = Object.freeze({
  'IGCSE Second Language': '95-100',
  'IGCSE Foreign Language': '90-95',
  MYP: '90-95',
  PYP: '90-95',
  AP: '95-100',
  'Primary School PTH': '90-95',
  'IB HL B': '100',
  'IB SL B': '95-100',
});

export const CONTENT_TAG_CATEGORIES_MAP = Object.freeze({
  focus: 'FOCUS',
  curriculumLevel: 'CURRICULUM_LEVEL',
  curriculumLevelTwo: 'CURRICULUM_LEVEL_TWO',
  topic: 'TOPIC',
  theme: 'THEME',
  subtheme: 'SUBTHEME',
  deprecated: 'DEPRECATED',
  curriculum: 'CURRICULUM',
  difficulty: 'DIFFICULTY',
  type: 'TYPE',
  misc: 'MISCELLANEOUS',
  metadata: 'METADATA',
  questionTopic: 'QUESTION_TOPIC',
  questionCustom: 'QUESTION_CUSTOM',
  questionMainTag1: 'QUESTION_MAIN_TAG_1',
  skillArea: 'SKILL_AREA',
  questionDifficulty: 'QUESTION_DIFFICULTY',
});

export const CONTENT_TAG_CATEGORIES_LIST = Object.values(CONTENT_TAG_CATEGORIES_MAP);

export const MEEOPP_ANALYTICS_EVENTS = {
  AVATAR_VIDEO: 'AVATAR_VIDEO',
};

export const REFRESH_TOKEN_JWT_KEY = 'MeeOppJWTRefreshToken';
export const ACCESS_TOKEN_JWT_KEY = 'MeeOppJWT';
export const MEEOPP_SERVICE_JWT_KEY = 'MeeOppServiceJWT';
export const MEEOPP_REDIRECT_TARGET_URL = 'MeeOppRedirectTargetUrl';
export const MEEOPP_USER_SELECTED_CLASS = 'MeeOppUserSelectedClass';
export const MAX_ROLLOVER_FLASHCARDS = 10;
export const LESSON_STATE_EVENTS = {
  writingPad: 'writingPad',
  slides: 'slides',
  currentSlide: 'currentSlide',
  previewHomework: 'previewHomework',
  rotateHomeworkImage: 'rotateHomeworkImage',
  changeHomeworkImage: 'changeHomeworkImage',
  stopwatch: 'stopwatch',
  stopwatchAction: 'stopwatchAction',
  emoji: 'emoji',
  audioPlayPush: 'audioPlayPush',
  changeAudio: 'changeAudio',
  endClass: 'endClass',
  lessonSnapshot: 'lessonSnapshot',
};

export const QUESTION_CHANGE_CHANNELS = {
  questionBox: 'QUESTION_BOX',
  quizReview: 'QUIZ_REVIEW',
};

export const QUALIFYING_YEARS = new Set([
  'YEAR_07',
  'YEAR_08',
  'YEAR_09',
  'YEAR_10',
  'YEAR_11',
  'YEAR_12',
  'YEAR_13',
]);

export const REWARD_SETTINGS_MAP = {
  videos: 'VIDEOS',
  blogPosts: 'BLOG_POSTS',
  manimal: 'MANIMAL',
};

export const GRADING_STATUSES = {
  notGraded: 'NOT_GRADED',
  gradingStarted: 'GRADING_STARTED',
  gradingComplete: 'GRADING_COMPLETE',
};

export const QUIZ_BOOKING_MODES = Object.freeze({
  practice: 'PRACTICE',
  assessment: 'ASSESSMENT',
});

export const LOGIN_TYPES = Object.freeze({
  code: 'CODE',
  emailPassword: 'EMAIL_PASSWORD',
  google: 'GOOGLE',
  emailAuth: 'EMAIL_AUTH',
});

export const FULL_ACCESS_LOGIN_TYPES = [
  LOGIN_TYPES.emailPassword,
  LOGIN_TYPES.google,
  LOGIN_TYPES.emailAuth,
];

export const CONTENT_TYPE = Object.freeze({
  topic: 'TOPIC',
  quiz: 'QUIZ',
  presentation: 'PRESENTATION',
  assessment: 'ASSESSMENT',
  corePack: 'CORE_PACK',
});

export const LOGIN_METHODS = {
  GOOGLE: 'google',
  EMAIL: 'email',
  SESSION_CODE: 'session code',
  TOKEN: 'token',
};

export const FOCUS_AREA_CODE = Object.freeze({
  reading: '010FA-010R',
  listening: '010FA-020L',
  writing: '010FA-030W',
  oral: '010FA-040O',
});

export const FIRST_EXPERIENCE_CODE = '900I-025FE';
export const INITIAL_ASSESSMENT_CODE = '900I-027IA';

export const LIBRARY_CONTENT_CONTENT_TYPE = {
  quiz: 'QUIZ',
  topic: 'TOPIC',
  presentation: 'PRESENTATION',
  assessment: 'ASSESSMENT',
  corePack: 'CORE_PACK',
  playbook: 'PLAYBOOK',
};

export const ESTIMATED_DURATION_CATEGORY = Object.freeze({
  long: 'LONG',
  veryLong: 'VERY_LONG',
  short: 'SHORT',
});

export const DURATION_CATEGORY_DISPLAY_MAP = Object.freeze({
  [ESTIMATED_DURATION_CATEGORY.short]: '< 5 minutes',
  [ESTIMATED_DURATION_CATEGORY.long]: '5-10 minutes',
  [ESTIMATED_DURATION_CATEGORY.veryLong]: '> 10 minutes',
});

export const NOTIFICATION_LANGUAGE = Object.freeze({
  traditionalChinese: 'TRADITIONAL_CHINESE',
  simplifiedChinese: 'SIMPLIFIED_CHINESE',
  english: 'ENGLISH',
});

export const GRADING_RATING = Object.freeze({
  thumbsUp: 'THUMBS_UP',
  thumbsDown: 'THUMBS_DOWN',
});

export const GradingStrategyName = {
  strictKeywordMatch: 'strict-keyword-match',
  sampleAnswerSimilarity: 'sample-answer-similarity',
  rubricText: 'rubric-text',
  directPromptChecklist: 'direct-prompt-checklist',
  pointTierRubric: 'point-tier-rubric',
};

export const RATING_EMOJIS = {
  TRIUMPH: assetUrl('triumph_emoji.png'),
  WEARY: assetUrl('weary_emoji.png'),
  SIMPLE_SMILE: assetUrl('simple_smile_emoji.png'),
  SMILEY: assetUrl('smiley_emoji.png'),
  HEART_EYES: assetUrl('heart_eyes_emoji.png'),
};

export const ASYNC_TASK_STATUSES = Object.freeze({
  pending: 'PENDING',
  completed: 'COMPLETED',
  error: 'ERROR',
  cancelled: 'CANCELLED',
});

export const ORGANIZATION_TYPES = Object.freeze({
  local: 'LOCAL',
  international: 'INTERNATIONAL',
  university: 'UNIVERSITY',
});
